module.exports = __webpack_public_path__ + "static/media/device-macbook-2_dbocag.d76e5a93.png";